module.exports = __webpack_public_path__ + "media/cars-backgournd-large.59feb4d7.mp4";